import {createUser} from 'Common/api';
import {initializeApp} from 'firebase/app';
import {getAuth, signInWithPopup, GoogleAuthProvider, User} from 'firebase/auth';
import {getDatabase, get, ref, set} from 'firebase/database';
import {User as RenditionUser} from 'rendition-core/types/Rendition';

const firebaseConfig = {
    apiKey: 'AIzaSyDZQZPXLi0VU0xtBUpc2f4tsI1PwtKSNQo',
    authDomain: 'rendition-prod.firebaseapp.com',
    databaseURL: 'https://rendition-prod-default-rtdb.firebaseio.com',
    projectId: 'rendition-prod',
    storageBucket: 'rendition-prod.appspot.com',
    messagingSenderId: '189821143124',
    appId: '1:189821143124:web:5c4416ca78f936497f45c1',
    measurementId: 'G-8JS0RHSFRM',
};

const provider = new GoogleAuthProvider();
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const auth = getAuth();

const signInWithGoogle = async (sessionId: string) => {
    /**
     * postconditions, success:
     *    session written with user id
     *    user found or created
     */
    const res = await signInWithPopup(auth, provider);

    // The signed-in user info.
    const user = res.user;

    return user;
};

export const signOutWithGoogle = async () => {
    const user = auth.currentUser;
    if (!user) {
        console.log('no logged in user');
        return;
    }
    await auth.signOut();
};

export async function createUserIfNotFound(sessionId: string, user: User) {
    const gUser = {
        email: user.email,
        name: user.displayName,
        photoUrl: user.photoURL,
    } as RenditionUser['googleUser'];

    const dbUser = await getUser(user.uid);
    console.log({user: dbUser.val()});
    if (!dbUser.exists()) {
        await createNewUser(user.uid, gUser);
    }
    await writeSessionData(sessionId, user.uid, true);
}

const getUser = async (uid: string) => {
    return get(ref(db, 'users/' + uid));
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getSession = async (uid: string) => {
    return get(ref(db, 'sessions/' + uid));
};

const createNewUser = async (uid: string, user: RenditionUser['googleUser']) => {
    // date 2 weeks from now

    await createUser({
        id: uid,
        googleUser: user,
    });
};

const writeSessionData = async (id: string, uid: string, loggedIn: boolean, trialCompiles = 0) => {
    await set(ref(db, 'sessions/' + id), {
        loggedIn,
        userId: uid,
        trialCompiles,
    });
};

export const getPublishData = async (alias: string) => {
    return await get(ref(db, 'publish/' + alias));
};

export const writePublishData = async (alias: string, pageId: string) => {
    await set(ref(db, 'publish/' + alias), {
        pageId: pageId,
    });
};

export {auth, getUser, signInWithGoogle};
